import React from "react";
import ReactDOM from "react-dom"
import { ChildrenEntry } from "../flexi/ChildrenEditor.jsx";

import update from "immutability-helper";
import { AuthorizedContacts } from "../flexi/AuthorizedContacts.jsx";


const InputRow = ({ label, children }) => (
    <div className="input-group">
        <label>{label}</label>
        {children}
    </div>);

class FunshineRow extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            afterschool: null,
            requireVoucher: false,
            voucherKey: "",
            voucher: "",
            breakfast: false
        }
    }

    upd(state){
        this.setState(state, () => {
            this.props.onChange(this.props.value, this.state.breakfast || (this.state.afterschool != null ));
        });
    }
    render(){
        
        return (
            <tr>
                <th>{this.props.label}</th>
                <td className="checkbox-options"><input type="checkbox" name="select_breakfast[]" value={this.props.value} checked={this.state.breakfast} onChange={() => this.upd({ breakfast: !this.state.breakfast })} id={"js-" + this.props.value + "-breakfast"}  /><label htmlFor={"js-" + this.props.value + "-breakfast"}></label></td>
                <td className="checkbox-options"><input type="checkbox" name="select_half[]" value={this.props.value} checked={this.state.afterschool == "half"} onChange={() => this.upd({ afterschool: (this.state.afterschool != "half") ? "half" : null }) } id={"js-" + this.props.value + "-half"} /><label htmlFor={"js-" + this.props.value + "-half"}></label></td>
                <td className="checkbox-options"><input type="checkbox" name="select_full[]" value={this.props.value} checked={this.state.afterschool == "full"} onChange={() => this.upd({ afterschool: (this.state.afterschool != "full") ? "full" : null }) } id={"js-" + this.props.value + "-full"} /><label htmlFor={"js-" + this.props.value + "-full"}></label></td>
            </tr>
        );
    }
}

class FunshineChildEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            kids: props.kids,
            termsAgreed: false,
            activeDays: [],
            paymentMethod: null
        }
        this.onDayRowChange = this.onDayRowChange.bind(this);
    }

    upd(spec) {
        this.setState(update(this.state, spec));
    }

    onDayRowChange(day, active){
        console.log("onDayRowChange", day, active);
        if(active && this.state.activeDays.indexOf(day) === -1){
            this.setState({ activeDays: [...this.state.activeDays, day] });
        }else if(!active && this.state.activeDays.indexOf(day) !== -1){
            
            this.setState({ activeDays: [...this.state.activeDays].splice(this.state.activeDays.indexOf(day), 1) });
        }
    }

    render() {
        const canRemove = (
            this.state.kids.length > 1
        );
        return <React.Fragment>
            <div className="js-ballpit">
                <div>
                    {this.state.kids.map((kid, idx) => <ChildrenEntry
                        key={idx}
                        idx={idx}
                        value={kid}
                        onChange={kid => this.upd({ kids: { [idx]: { $set: kid } } })}
                        onRemove={canRemove ? () => this.upd({ kids: { $splice: [[idx, 1]] } }) : null}
                    />)}

                    <button type="button" id="js-add-kid" onClick={() => this.upd({ kids: { $push: [{ dob: `${(new Date()).getFullYear() - 3}-01-01` }] } })}>Add Child</button>

                </div>
                <div>
                    <h3>Contact Details</h3>
                    <fieldset>
                        <InputRow label="Parent Name"><input type="text" name="parent-name" required /></InputRow>
                        <div className="grouped-inputs-1">
                            <InputRow label="Primary Contact No. *"><input type="tel" pattern="\d{11}" title="Enter a valid phone number (11 digits, no spaces)" name="parent-tel" required /></InputRow>
                            <InputRow label="Second Contact No. *"><input type="tel" pattern="\d{11}" title="Enter a valid phone number (11 digits, no spaces)" name="parent-tel-2" required /></InputRow>
                        </div>
                        <InputRow label="Email"><input type="text" name="parent-email" required /></InputRow>
                    </fieldset>

                    <AuthorizedContacts />
                </div>
            </div>
            

            
            <h2>Choose your sessions</h2>

            <fieldset>
                <InputRow label="Start date *">
                    <input className="datepicker" type="text" name="start_date" required />
                </InputRow>
            </fieldset>


            <table id="wrap-around-selector">
                <thead>
                    <tr>
                        <th></th>
                        <th>
                                Breakfast Club
                            <span>{this.props.times[0]}</span>
                            <span>&pound;{this.props.pricing[0]} per day</span>
                        </th>
                        <th>
                                After School Club
                            <span>{this.props.times[1]}</span>
                            <span>Half: &pound;{this.props.pricing[1]} per day</span>
                        </th>
                        <th>
                                After School Club
                            <span>{this.props.times[2]}</span>
                            <span>Full: &pound;{this.props.pricing[2]} per day</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <FunshineRow label="Mon" value="monday" onChange={this.onDayRowChange} />
                    <FunshineRow label="Tue" value="tuesday" onChange={this.onDayRowChange} />
                    <FunshineRow label="Wed" value="wednesday" onChange={this.onDayRowChange} />
                    <FunshineRow label="Thu" value="thursday" onChange={this.onDayRowChange} />
                    <FunshineRow label="Fri" value="friday" onChange={this.onDayRowChange} />
                </tbody>
            </table>               

            <div className="radio-container">
                <div className="radio-payment-options">
                    <div className="grid-container smaller">
                        <h3>Payment method</h3>
                        <p>
                                Please select your preferred method of payment for your monthly Invoice fees
                        </p>

                        <div className="confirm">
                            <div className="i-group">
                                <input type="radio" id={"pay-by-bacs"} name={"pay-by"} value="bacs" onChange={() => this.setState({ paymentMethod: "bacs", requireVoucher: false })} /> 
                                <label htmlFor={"pay-by-bacs"}><span>Pay by BACs <i>BACs information will be provided on your Invoice</i></span></label>
                            </div>
                        </div>

                        <div className="confirm">
                            <div className="i-group">
                                <input type="radio" id={"pay-by-online"} name={"pay-by"} value="online" onChange={() => this.setState({ paymentMethod: "online", requireVoucher: false })} /> 
                                <label htmlFor={"pay-by-online"}><span>Pay Online <i>Debit / Credit / PayPal</i></span></label>
                            </div>
                        </div>

                        <div className="confirm">
                            <div className="i-group">
                                <input type="radio" id={"pay-by-voucher"} name={"pay-by"} value="voucher" onChange={() => this.setState({ paymentMethod: "voucher", requireVoucher: true })} />                
                                <label htmlFor={"pay-by-voucher"}><span>Pay using childcare vouchers <i>Please confirm which Childcare voucher you would like to use:</i></span></label>

                                <select value={this.state.voucherKey} onChange={ev => this.setState({ voucherKey: ev.target.value, voucher: this.props.voucher[ev.target.value] })}>
                                    {Object.keys(this.props.voucher).map( e => <option key={e} value={e}>{e}</option>)}
                                </select>
                            </div>
                        </div>
                            
                            
                    </div>
                </div>
            </div>

            <div className="breakout-container checkbox-container">
                <div className="check-confirmations">
                    <div className="grid-container smaller">
                        <div className="confirm">
                            <div className="i-group">
                                <input type="checkbox" name="terms[]" value="yes" id="chk-terms-1" checked={this.state.termsAgreed1} onChange={() => this.setState({ termsAgreed1: !this.state.termsAgreed1 })} />
                                <label htmlFor="chk-terms-1"><span>By completing and submitting this registration form, I am entering into an agreement with Funshine Club and I will give a minimum of one month’s notice if I wish to cancel my place.</span></label>
                            </div>
                        </div>
                        <div className="confirm">
                            <div className="i-group">
                                <input type="checkbox" name="terms[]" value="yes" id="chk-terms-2" checked={this.state.termsAgreed2} onChange={() => this.setState({ termsAgreed2: !this.state.termsAgreed2 })} />
                                <label htmlFor="chk-terms-2"><span>I understand the club is open for 39 term-time weeks. During this period Bank holidays, Inset days, polling days and unexpected school closures are chargeable at a normal daily rate.</span></label>
                            </div>
                        </div>
                        <div className="confirm">
                            <div className="i-group">
                                <input type="checkbox" name="terms[]" value="yes" id="chk-terms-3" checked={this.state.termsAgreed3} onChange={() => this.setState({ termsAgreed3: !this.state.termsAgreed3 })} />
                                <label htmlFor="chk-terms-3"><span>I have read and will abide by the Clubs Terms &amp; Conditions, Policies, and Procedures which are available <a href="/TandCs-.html" target="_blank">here</a> for reference.</span></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* START */}
            <div className="chosen-options">
                <div className="days">
                    <div className="icon">
                        <img src="/Templates/steps2sport/images/dates.png" alt="Active Superstars Ltd" />
                    </div>
                    <div className="info">{this.state.activeDays.length}&nbsp;day{this.state.activeDays.length != 1 ? "s": ""}</div>
                </div>
    
                <div className="multply">
                    <img src="/Templates/steps2sport/images/multiply.png" alt="Active Superstars Ltd" />
                </div>

                <div className="num-children">
                    <div className="icon">
                        <img src="/Templates/steps2sport/images/child.png" alt="Active Superstars Ltd" />
                    </div>
                    <div className="info">{this.state.kids.length}&nbsp;child{this.state.kids.length != 1 ? "ren" : ""}</div>
                </div>
            </div>

            <div className="pre-button-text">
                <p>A registration fee of &pound;15.00 (non-refundable) will need to be paid to complete your registration.</p>
                <p>When you submit your registration form you will be asked to visit our payment page.</p>
            </div>
            {/* END */}

            <button
                type="submit"
                disabled={
                    !this.state.termsAgreed1 || 
                        !this.state.termsAgreed2 || 
                        !this.state.termsAgreed3 ||
                        !this.state.paymentMethod
                }>Sign up to funshine</button>
        </React.Fragment>
    }
}


export function renderFunshineEditor(element, children = [], voucherData = {}, pricing = [], times=[]) {

    ReactDOM.render(<FunshineChildEditor kids={children} voucher={voucherData} pricing={pricing} times={times} />, element);

}


// WEBPACK FOOTER //
// ./funshine/main.jsx